<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <button
          *ngIf="!isList"
          routerLink="/reportage-details"
          title="{{ 'inputs.back' | translate }}"
          mat-icon-button
        >
          <mat-icon>keyboard_backspace</mat-icon>
          {{ "inputs.back" | translate }}
        </button>

        <button
        *ngIf="!isList"
        mat-raised-button
        routerLink="/reportage-details/{{ studentForm.value.next_photoReportage }}"
        style="float: right"
      >
        <span> {{ "inputs.next" | translate }} </span>
      </button>

        <h1 *ngIf="isList">{{ "titles.list.reportage_photos" | translate }}</h1>
        <h1 *ngIf="!isList">{{ "titles.edit.reportage_photo" | translate }}</h1>
        <div *ngIf="!isList && !isNew">
          <div *ngFor="let photo of student_photo">
            <p style="float: left">
              <a
                [href]="photo.imageUrl"
                target="_blank"
                matTooltip="{{ 'captions.individual_photo' | translate }}"
                ><img [src]="photo.imageUrl"
              /></a>
            </p>

            <p>
              {{ "inputs.creation_date" | translate }}:
              {{ creation_date | date: "d/M/Y, H:mm:ss" }} <br />
              {{ "inputs.modification_date" | translate }}:
              {{ modification_date | date: "d/M/Y, H:mm:ss" }}
            </p>
          </div>
        </div>
        <div *ngIf="isList" class="clear-filters-button-wrapper">
          <button
            mat-mini-fab
            type="button"
            (click)="clearFilters()"
            [ngClass]="
              disableClearFilterButton || showStudentPhotosProgressBar
                ? 'disabled-clear-filters-button'
                : 'clear-filters-button'
            "
            [disabled]="
              disableClearFilterButton || showStudentPhotosProgressBar
            "
          >
            <mat-icon>replay</mat-icon>
          </button>
        </div>
        <div style="clear: left"></div>

        <div class="media-body">
          <mat-form-field *ngIf="isList">
            <mat-label>{{ "inputs.search" | translate }}</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              id="input"
              placeholder="{{ 'inputs.search' | translate }}"
              #input
            />
          </mat-form-field>
          <div
            *ngIf="isList"
            id="divFilter"
            [formGroup]="filterForm"
            class="filter-panel"
          >
            <label style="padding-right: 20px"
              >{{ "inputs.filter" | translate }}:
            </label>
            <mat-form-field appearance="legacy">
              <mat-label>{{ "inputs.reportages" | translate }}</mat-label>
              <mat-select
                matNativeControl
                [formControlName]="'reportages'"
                (selectionChange)="applyFilter($event.value)"
              >
                <mat-option
                  *ngFor="let reportage of reportages"
                  [value]="reportage.id"
                >
                  {{ reportage.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.lines' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'lines'">
                  <mat-option *ngFor="let line of lines" [value]="line.id">
                    {{line.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->
            <!-- <div>
                <button mat-mini-fab type="button" (click)='clearFilters()'
                  [ngClass]="disableClearFilterButton ? 'disabled-clear-filters-button' : 'clear-filters-button'"
                  [disabled]="disableClearFilterButton">
                  <mat-icon>replay</mat-icon>
                </button>
              </div> -->
          </div>

          <div
            *ngIf="isList && dataSource && !dataSource[0]"
            style="
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              margin: 26px 0;
            "
          >
            <h1 style="font-size: 14px">
              {{ "titles.list.select_reportage" | translate }}
            </h1>
          </div>

          <div *ngIf="isList">
            <!-- && dataSource-->
            <table mat-table [dataSource]="dataSource">
              <!-- Second Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                >
                  {{ element.name }}
                </td>
              </ng-container>

              <!-- Third Column -->
              <ng-container matColumnDef="reportage">
                <th mat-header-cell *matHeaderCellDef fxHide.lt-sm>
                  {{ "tables.reportage" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                  fxHide.lt-sm
                >
                  {{ element.reportage_name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modification_date">
                <th mat-header-cell *matHeaderCellDef fxHide.lt-sm>
                  {{ "tables.modification_date" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.id)"
                  fxHide.lt-sm
                >
                  {{ element.modification_date | date: "yyyy-MM-dd H:mm:ss" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.actions" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    matTooltip="{{ 'inputs.delete' | translate }}"
                    class="iconbutton"
                    (click)="deletePhoto(element.id)"
                    color="warn"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                  <!--
                  <button mat-icon-button matTooltip="Click to reset password" class="iconbutton"
                    (click)="resetPassword(element.id)">
                    <mat-icon>vpn_key</mat-icon>
                  </button> -->
                  <button
                    mat-icon-button
                    matTooltip="{{ 'inputs.edit' | translate }}"
                    (click)="goTo(element.id)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="loading">
                <td mat-footer-cell *matFooterCellDef colspan="6">
                  <span>{{ "tables.loading" | translate }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr
                mat-footer-row
                *matFooterRowDef="['loading']"
                [hidden]="!showStudentPhotosProgressBar"
              ></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="6">
                  <span *ngIf="!showStudentPhotosProgressBar">{{
                    "tables.no_data_found" | translate
                  }}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar
              *ngIf="showStudentPhotosProgressBar"
              mode="indeterminate"
            ></mat-progress-bar>
            <mat-paginator
              [length]="totalItems"
              [pageSizeOptions]="[100, 50, 200]"
              (page)="pageEvent = $event; onPaginateChange($event)"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>

          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" [formGroup]="studentForm" *ngIf="!isList">
            <input
              matInput
              [hidden]="true"
              [formControlName]="'id'"
              type="text"
              placeholder="id"
            />
            <mat-form-field>
              <input
                matInput
                required
                [formControlName]="'name'"
                type="text"
                placeholder="{{ 'inputs.name' | translate }}"
              />
            </mat-form-field>

            <mat-form-field class="columns">
              <mat-label *ngIf="selectedFiles; else newFile">{{
                selectedFiles.item(0).name
              }}</mat-label>
              <ng-template #newFile>
                <mat-label>{{
                  "inputs.choose_primary_image" | translate
                }}</mat-label>
              </ng-template>
              <input matInput disabled />
              <button
                mat-icon-button
                matSuffix
                (click)="fileInput_primary.click()"
              >
                <mat-icon>attach_file</mat-icon>
              </button>
              <input
                hidden
                (change)="selectFile($event, 'primary')"
                #fileInput_primary
                type="file"
                id="file"
                accept="{{ type_accept }}"
              />
            </mat-form-field>
            <button
              mat-flat-button
              style="background-color: #5fbeb5; max-width: fit-content"
              (click)="deletePhoto(studentForm.value.id)"
              *ngIf="!isNew"
            >
              <span style="color: white">{{
                "buttons.delete_photo" | translate
              }}</span>
            </button>

            <!-- <mat-form-field class="columns">
                <mat-label *ngIf="selectedSecondaryFiles; else newSecondaryFile">{{selectedSecondaryFiles.item(0).name}}
                </mat-label>
                <ng-template #newSecondaryFile>
                  <mat-label>{{ 'inputs.choose_secondary_image' | translate }}</mat-label>
                </ng-template>
                <input matInput disabled>
                <button mat-icon-button matSuffix (click)="fileInput_secondary.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input hidden (change)="selectFile($event, 'secondary')" #fileInput_secondary type="file"
                  id="secondaryfile" accept={{type_accept}}>
              </mat-form-field>
              <button mat-flat-button style="background-color: #5fbeb5;max-width: fit-content;"
                (click)="deletePhoto('secondary')" *ngIf='!isNew'>
                <span style="color: white;">{{ 'buttons.delete_secondary_photo' | translate}}</span>
              </button> -->
          </div>
          <!-- </mat-card> -->

          <mat-progress-bar
            *ngIf="showStudentPhotosProgressBar2"
            mode="indeterminate"
          ></mat-progress-bar>

          <!-- <div class="float-button-container" *ngIf='isList'>
              <button mat-fab color="primary" aria-label="add" (click)="newStudent()">
                <mat-icon>plus_one</mat-icon>
              </button>
            </div> -->
          <div class="float-button-container" *ngIf="!isList">
            <button
              mat-fab
              color="primary"
              aria-label="save"
              (click)="saveReportagephoto()"
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
